import {
  getIdentitiesData,
  getGroupIdentitiesData,
  addIdentityData,
  editIdentityData,
  editIdentityStatusData,
  editIdentityGroupStatusData,
  editIdentityGroupData,
  getIdentityUserKidData,
  editIdentityUserKidStatusData,
  getIdentityUserKidsDetailData
} from '../libs/apis/IdentityApi';

export const GET_IDENTITIES_REQUEST = 'GET_IDENTITIES_REQUEST';
export const GET_IDENTITIES_SUCCESS = 'GET_IDENTITIES_SUCCESS';
export const GET_IDENTITIES_FAILURE = 'GET_IDENTITIES_FAILURE';

export const GET_GROUP_IDENTITIES_REQUEST = 'GET_GROUP_IDENTITIES_REQUEST';
export const GET_GROUP_IDENTITIES_SUCCESS = 'GET_GROUP_IDENTITIES_SUCCESS';
export const GET_GROUP_IDENTITIES_FAILURE = 'GET_GROUP_IDENTITIES_FAILURE';

export const ADD_IDENTITY_REQUEST = 'ADD_IDENTITY_REQUEST';
export const ADD_IDENTITY_SUCCESS = 'ADD_IDENTITY_SUCCESS';
export const ADD_IDENTITY_FAILURE = 'ADD_IDENTITY_FAILURE';

export const EDIT_IDENTITY_REQUEST = 'EDIT_IDENTITY_REQUEST';
export const EDIT_IDENTITY_SUCCESS = 'EDIT_IDENTITY_SUCCESS';
export const EDIT_IDENTITY_FAILURE = 'EDIT_IDENTITY_FAILURE';

export const EDIT_IDENTITY_GROUP_REQUEST = 'EDIT_IDENTITY_GROUP_REQUEST';
export const EDIT_IDENTITY_GROUP_SUCCESS = 'EDIT_IDENTITY_GROUP_SUCCESS';
export const EDIT_IDENTITY_GROUP_FAILURE = 'EDIT_IDENTITY_GROUP_FAILURE';

export const EDIT_IDENTITY_STATUS_REQUEST = 'EDIT_IDENTITY_STATUS_REQUEST';
export const EDIT_IDENTITY_STATUS_SUCCESS = 'EDIT_IDENTITY_STATUS_SUCCESS';
export const EDIT_IDENTITY_STATUS_FAILURE = 'EDIT_IDENTITY_STATUS_FAILURE';

export const EDIT_IDENTITY_GROUP_STATUS_REQUEST =
  'EDIT_IDENTITY_GROUP_STATUS_REQUEST';
export const EDIT_IDENTITY_GROUP_STATUS_SUCCESS =
  'EDIT_IDENTITY_GROUP_STATUS_SUCCESS';
export const EDIT_IDENTITY_GROUP_STATUS_FAILURE =
  'EDIT_IDENTITY_GROUP_STATUS_FAILURE';

export const GET_IDENTITY_USER_KIDS_REQUEST = 'GET_IDENTITY_USER_KIDS_REQUEST';
export const GET_IDENTITY_USER_KIDS_SUCCESS = 'GET_IDENTITY_USER_KIDS_SUCCESS';
export const GET_IDENTITY_USER_KIDS_FAILURE = 'GET_IDENTITY_USER_KIDS_FAILURE';

export const EDIT_IDENTITY_USER_KID_STATUS_REQUEST =
  'EDIT_IDENTITY_USER_KID_STATUS_REQUEST';
export const EDIT_IDENTITY_USER_KID_STATUS_SUCCESS =
  'EDIT_IDENTITY_USER_KID_STATUS_SUCCESS';
export const EDIT_IDENTITY_USER_KID_STATUS_FAILURE =
  'EDIT_IDENTITY_USER_KID_STATUS_FAILURE';

export const GET_IDENTITY_USER_KIDS_DETAIL_REQUEST =
  'GET_IDENTITY_USER_KIDS_DETAIL_REQUEST';
export const GET_IDENTITY_USER_KIDS_DETAIL_SUCCESS =
  'GET_IDENTITY_USER_KIDS_DETAIL_SUCCESS';
export const GET_IDENTITY_USER_KIDS_DETAIL_FAILURE =
  'GET_IDENTITY_USER_KIDS_DETAIL_FAILURE';

export const getIdentities = params => dispatch => {
  dispatch({ type: GET_IDENTITIES_REQUEST });
  return getIdentitiesData(params)
    .then(response =>
      dispatch({
        type: GET_IDENTITIES_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_IDENTITIES_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getGroupIdentities = params => dispatch => {
  dispatch({ type: GET_GROUP_IDENTITIES_REQUEST });
  return getGroupIdentitiesData(params)
    .then(response =>
      dispatch({
        type: GET_GROUP_IDENTITIES_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_GROUP_IDENTITIES_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const addIdentity = params => dispatch => {
  dispatch({ type: ADD_IDENTITY_REQUEST });
  return addIdentityData(params)
    .then(response =>
      dispatch({
        type: ADD_IDENTITY_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: ADD_IDENTITY_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const editIdentity = (identityId, params) => dispatch => {
  dispatch({ type: EDIT_IDENTITY_REQUEST });
  return editIdentityData(identityId, params)
    .then(response =>
      dispatch({
        type: EDIT_IDENTITY_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: EDIT_IDENTITY_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const editIdentityGroup = (identityId, params) => dispatch => {
  dispatch({ type: EDIT_IDENTITY_GROUP_REQUEST });
  return editIdentityGroupData(identityId, params)
    .then(response =>
      dispatch({
        type: EDIT_IDENTITY_GROUP_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: EDIT_IDENTITY_GROUP_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const editIdentityStatus = (identityId, params) => dispatch => {
  dispatch({ type: EDIT_IDENTITY_STATUS_REQUEST });
  return editIdentityStatusData(identityId, params)
    .then(response =>
      dispatch({
        type: EDIT_IDENTITY_STATUS_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: EDIT_IDENTITY_STATUS_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const editIdentityGroupStatus = (identityId, params) => dispatch => {
  dispatch({ type: EDIT_IDENTITY_GROUP_STATUS_REQUEST });
  return editIdentityGroupStatusData(identityId, params)
    .then(response =>
      dispatch({
        type: EDIT_IDENTITY_GROUP_STATUS_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: EDIT_IDENTITY_GROUP_STATUS_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getIdentityUserKids = params => dispatch => {
  dispatch({ type: GET_IDENTITY_USER_KIDS_REQUEST });
  return getIdentityUserKidData(params)
    .then(response =>
      dispatch({
        type: GET_IDENTITY_USER_KIDS_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_IDENTITY_USER_KIDS_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const editIdentityUserKidStatus = params => dispatch => {
  dispatch({ type: EDIT_IDENTITY_USER_KID_STATUS_REQUEST });
  return editIdentityUserKidStatusData(params)
    .then(response =>
      dispatch({
        type: EDIT_IDENTITY_USER_KID_STATUS_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: EDIT_IDENTITY_USER_KID_STATUS_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getIdentityUserKidsDetail = userKidId => dispatch => {
  dispatch({ type: GET_IDENTITY_USER_KIDS_DETAIL_REQUEST });
  return getIdentityUserKidsDetailData(userKidId)
    .then(response =>
      dispatch({
        type: GET_IDENTITY_USER_KIDS_DETAIL_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_IDENTITY_USER_KIDS_DETAIL_FAILURE,
        payload: error.response,
        error: true
      })
    );
};
